<template>
  <div>
    <h6 class="title is-6">{{ $t("projects.domainListTitle") }}</h6>
    <div class="field">
      <label class="checkbox" v-if="isEnableModal">
        <div class="control">
          <input
            type="checkbox"
            v-model="isEnableDomianList"
            @change="changeIsEnableDomianList"
          />
          {{ $t("projects.enableDomainCheck") }}
        </div>
      </label>
    </div>
    <div class="buttons">
      <button
        v-if="
          isEnableModal &&
            isEnableDomianList &&
            countDomain(allowedEmailDomains)
        "
        @click="modalChange('add')"
        class="button has-tooltip-arrow"
      >
        <span class="icon is-small">
          <i class="fas fa-plus"></i>
        </span>
        <span>{{ $t("projects.addAllowDomain") }}</span>
      </button>
    </div>
    <AlertMessage
      v-if="isEnableModal && isEnableDomianList"
      color="is-info"
      :message="$t('projects.ownerDomainInfo', { domain: useDomain })"
    ></AlertMessage>

    <AlertMessage
      v-if="!countDomain(allowedEmailDomains)"
      color="is-danger"
      :message="$t('projects.domainErrorMax')"
    ></AlertMessage>

    <AlertMessage color="is-info" :message="memberMessage"></AlertMessage>
    <table class="table is-fullwidth is-hoverable">
      <thead>
        <tr>
          <th>{{ $t("projects.allowedDomain") }}</th>
          <th v-if="isEnableModal && isEnableDomianList">#</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in allowedEmailDomains"
          :key="index"
          :class="backgroundcolor(isEnableDomianList)"
        >
          <td>{{ item }}</td>
          <td>
            <a @click="modalChange('delDomain', item)">
              <span
                v-if="isEnableModal && isEnableDomianList"
                class="icon-text"
              >
                <span class="icon">
                  <i class="fas fa-edit"></i>
                </span>
              </span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="modal" v-bind:class="{ 'is-active': addModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <Form
          @submit="doAddDmian"
          :validation-schema="schema"
          v-slot="{ errors }"
        >
          <header class="modal-card-head">
            <p class="modal-card-title">
              {{ $t("projects.addAllowDomain") }}
            </p>
          </header>
          <section class="modal-card-body">
            <div class="content">
              <AlertMessage
                color="is-info"
                :message="$t('projects.addMemberMessage')"
              ></AlertMessage>

              <div class="field">
                <label class="label"
                  >{{ $t("projects.allowedDomain") }} *</label
                >
                <p>{{ $t("projects.allowedDomainMessage") }}</p>
                <div class="control">
                  <Field
                    @input="checkEmailDomain"
                    name="emailDomain"
                    class="input"
                    required="required"
                    :class="{ 'is-danger': errors.emailDomain }"
                  />
                  <span class="help is-danger">{{ errors.emailDomain }}</span>
                </div>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button @click="modalChange('add')" class="button" type="reset">
              Cancel
            </button>

            <button
              type="submit"
              class="button ml-3 is-primary"
              v-bind:class="{ 'is-loading': isLoad }"
              :disabled="isSubmit"
            >
              {{ $t("Add") }}
            </button>
          </footer>
        </Form>
      </div>
    </div>

    <div class="modal" v-bind:class="{ 'is-active': delDomainModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("projects.deleteAllowDomain") }}</p>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <h6 class="title is-6">{{ $t("projects.deleteAllowDomain") }}</h6>
            <AlertMessage
              color="is-danger"
              :message="changeDomian + 'を削除しますか？'"
            ></AlertMessage>
            <button @click="doDelMember(changeDomian)" class="button is-danger">
              {{ $t("Delete") }}
            </button>
          </div>
        </section>
        <footer class="modal-card-foot text-has-right">
          <button @click="modalChange('del')" class="button">Close</button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import AlertMessage from "@/components/AlertMessage.vue";
import imsr from "@/imsr-api";
import { ImsrProjects } from "@/lib/imsrProjects.js";
import { computed, ref } from "@vue/reactivity";
import { Field, Form } from "vee-validate";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import * as Yup from "yup";

export default {
  props: {
    projectId: {
      type: String,
      require: true,
    },
    tenantId: {
      type: String,
      require: true,
    },
    company: {
      type: String,
      require: true,
    },
    useCount: {
      type: Number,
      require: true,
    },
    isSecondaryUse: {
      type: Boolean,
      require: true,
    },
  },
  components: {
    AlertMessage,
    Form,
    Field,
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();

    const allowedEmailDomains = ref([]);
    const useDomain = ref("");
    const isLoad = ref(false);
    const addModal = ref(false);
    const memberMessage = ref("");
    const delDomainModal = ref(false);
    const changeDomian = ref("");
    const deleteMessage = ref("");
    const isSubmit = ref(true);
    const isEnableModal = ref(false);
    const isEnableDomianList = ref(false);

    const loadDomian = async () => {
      try {
        const imsrProjects = new ImsrProjects();
        const res_tenant = await imsr.imsrGetApi("/tenants", {
          tenantId: store.getters.tenantId,
        });
        const res_project = await imsrProjects.getProject(
          props.tenantId,
          props.projectId
        );
        isEnableDomianList.value = res_project.isEnableChackEmailDomain;
        if (res_project.secondaryUse == "true") {
          isEnableModal.value = true;
          allowedEmailDomains.value = res_project.allowedEmailDomains;
          useDomain.value = res_tenant.useDomain;
        } else {
          isEnableModal.value = false;
          useDomain.value = res_tenant.useDomain;
          allowedEmailDomains.value = [res_tenant.useDomain];
        }
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };

    loadDomian();

    const modalChange = (modal, Domain = "") => {
      if (modal == "add") {
        addModal.value = !addModal.value;
      } else {
        if (Domain != "") {
          changeDomian.value = Domain;
        }
        delDomainModal.value = !delDomainModal.value;
      }
    };

    const schema = Yup.object().shape({
      emailDomain: Yup.string()
        .matches(/^[a-z0-9.-]+\.[a-z]{2,}$/, t("validate.domain"))
        .required(t("validate.required")),
    });
    const doAddDmian = async (memberValue) => {
      try {
        isLoad.value = true;
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          emailDomain: memberValue.emailDomain,
        };
        await imsr.imsrPostApi("/projects/allowdomain", params);
        loadDomian();
        memberMessage.value = t("projects.addMemberSuccess");
      } catch (e) {
        switch (e.message) {
          case "validation error.":
            memberMessage.value = t("projects.addMemberValidateError");
            break;
          case "user exists.":
            memberMessage.value = t("projects.addMemberExist");
            break;
          case "The number of participants has reached the limit.":
            memberMessage.value = t("projects.addMemberLimit");
            break;
          case "Can not use other domain.":
            memberMessage.value = t("projects.domainError");
            break;
          default:
            router.push({ name: "InternalServerError" });
        }
      }
      addModal.value = false;
      isLoad.value = false;
      emit("refreshParent");
    };

    const doDelMember = async (domain) => {
      try {
        isLoad.value = true;
        const params = {
          projectId: props.projectId,
          tenantId: props.tenantId,
          emailDomain: domain,
        };
        await imsr.imsrDeleteApi("/projects/allowdomain", params);
      } catch (e) {
        if (e.message == "can not be delete last admin.") {
          memberMessage.value = t("projects.deleteMemberErrorLastAdmin");
        } else {
          router.push({ name: "InternalServerError" });
        }
      }
      isLoad.value = false;
      delDomainModal.value = false;
      loadDomian();
      emit("refreshParent");
    };

    const checkEmailDomain = (val) => {
      const domainRegex = /^[a-z0-9.]+\.[a-z0-9.]+$/;
      if (domainRegex.test(val)) {
        isSubmit.value = true;
      } else {
        isSubmit.value = false;
      }
    };

    const changeIsEnableDomianList = async () => {
      try {
        isLoad.value = true;
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          isEnableChackEmailDomain: isEnableDomianList.value,
        };
        await imsr.imsrPostApi("/projects/allowdomain/setenable", params);
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
      isLoad.value = false;
      emit("refreshParent");
    };

    return {
      isLoad,
      allowedEmailDomains,
      isEnableModal,
      changeDomian,
      schema,
      addModal,
      delDomainModal,
      modalChange,
      doAddDmian,
      doDelMember,
      memberMessage,
      deleteMessage,
      userId: computed(() => store.getters.userId),
      checkEmailDomain,
      isSubmit,
      isEnableDomianList,
      changeIsEnableDomianList,
      useDomain,
    };
  },
  methods: {
    backgroundcolor(isDomainNotMatch) {
      if (isDomainNotMatch) {
        return "background-color";
      } else {
        return "imsr-unEnable";
      }
    },
    countDomain(domainList) {
      if (domainList.length < 5) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.imsr-unEnable {
  background-color: hsl(0, 0%, 87%);
}
.imsr-enable {
  background-color: hsl(0, 0%, 100%);
}
.imsr-camera-icon {
  margin-right: 4px;
}
</style>
